<div class="-my-3" *ngIf="client && client.is_blacklisted" [attr.data-testid]="'blacklisted-message'">
    <p-message severity="error" icon="fa fa-triangle-exclamation" aria-label="blacklisted-message">
        {{client.blacklisted_reason}}
    </p-message>
</div>

<div class="-my-3" *ngIf="client && client.is_irregular" [attr.data-testid]="'irregular-client-message'">
    <p-message severity="error" icon="fa fa-triangle-exclamation" aria-label="irregular-client-message">
        {{'CLIENT_PROFILE.IS_AT_RISK' | translate}}
    </p-message>    
</div>  

<!-- Row -->
<div class="lg:flex" [attr.data-testid]="'client-profile-container'">
    
    <!-- Left Side -->
    <div class="lg:w-3 border-right-1 border-300" [ngClass]="currentTenantClient ? 'surface-0' : 'bg-yellow-100'" [attr.data-testid]="'client-profile-left-side'">
        <client-profile-left-side [clientDetails]="client!" [tenantId]="tenantId" [showSkeleton]="showSkeleton$" (closeClientSidebar)="closeSidebar($event)" (changeEvent)="changeEvent($event)"></client-profile-left-side>
    </div>
    <!-- Left Side -->

    <!-- Right Side -->
    <div class="lg:w-9 md:pr-3 lg:pb-3 surface-200 z-1" [attr.data-testid]="'client-profile-right-side'">
        <p-tabs [value]="activeIndex.toString()" scrollable (valueChange)="onTabChange($event)">
            <p-tablist aria-labelledby="client-profile-tabs">
                <p-tab *ngFor="let tab of clientOverviewTabs; let i = index" 
                       [value]="i.toString()" 
                       [attr.data-testid]="'tab-header-' + tab.title.toLowerCase()" 
                       [attr.aria-label]="tab.title.toLowerCase() + '-tab'"
                       [attr.aria-controls]="'tab-content-' + i"
                       class="flex align-items-center white-space-nowrap text-xs md:text-sm"
                       [ngClass]="{'lg:hidden': tab.key === 'clientsummary'}">
                    <i class="{{tab.icon}} mr-2" [attr.data-testid]="'tab-icon-' + tab.title.toLowerCase()"></i>
                    <span [attr.data-testid]="'tab-title-' + tab.title.toLowerCase()" [attr.id]="'tab-label-' + i">{{'CLIENT_PROFILE.TABS.'+tab.title | translate}}</span>
                </p-tab>
            </p-tablist>
            <p-tabpanels>
                <!-- Client Summary Panel -->
                <p-tabpanel [value]="'0'" [attr.aria-label]="'clientsummary-panel'" [attr.id]="'tab-content-0'" [attr.aria-labelledby]="'tab-label-0'">
                    <ng-container *ngIf="activeIndex === 0 && clientId">
                        <div class="surface-100 lg:pb-8" [attr.data-testid]="'client-summary-tab-content'">
                            <client-profile-details-tab [showSkeleton]="showSkeleton$" [clientDetails]="client!" [tenantId]="tenantId"></client-profile-details-tab>
                        </div>
                    </ng-container>
                </p-tabpanel>
                
                <!-- Overview Panel -->
                <p-tabpanel [value]="'1'" [attr.aria-label]="'overview-panel'" [attr.id]="'tab-content-1'" [attr.aria-labelledby]="'tab-label-1'">
                    <ng-container *ngIf="activeIndex === 1 && clientId">
                        <div class="surface-100 lg:pb-8" [attr.data-testid]="'overview-tab-content'">
                            <client-overview-tab [showSkeleton]="showSkeleton$" [interactions]="clientInteractions$" [clientDetails]="client!" [clientId]="clientId"
                              (changeTab)="changeTabClick($event)" [clickFromTab]="clickfromTab" [tenantId]="tenantId" [clientReferrals]="clientReferrals$" [clientOffers]="clientCoupons$"
                              (reloadData)="reloadData($event)" [interactionId]="interactionId" [height]="overViewHeight">
                            </client-overview-tab>
                        </div>
                    </ng-container>
                </p-tabpanel>
                
                <!-- Activity Feed Panel -->
                <p-tabpanel [value]="'2'" [attr.aria-label]="'activity-feed-panel'" [attr.id]="'tab-content-2'" [attr.aria-labelledby]="'tab-label-2'">
                    <ng-container *ngIf="activeIndex === 2 && clientId">
                        <div class="surface-100 lg:pb-8 px-3 pt-2 activity-feeds" [attr.data-testid]="'activity-feed-tab-content'">
                            <client-interaction-tab [clientId]="clientId" [interactions]="clientInteractions$" [showSkeleton]="showSkeleton$" [clickFromTab]="clickfromTab" [showMax]="0" [showCollapsed]="showCollapsed$" [clientDetails]="client!"
                              [height]="activityHeight" [interactionId]="interactionId">
                            </client-interaction-tab>
                        </div>
                    </ng-container>
                </p-tabpanel>
                
                <!-- Booking Panel -->
                <p-tabpanel [value]="'3'" [attr.aria-label]="'booking-panel'" [attr.id]="'tab-content-3'" [attr.aria-labelledby]="'tab-label-3'">
                    <ng-container *ngIf="activeIndex === 3 && clientId">
                        <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'booking-tab-content'">
                            <client-booking-tab [clientId]="clientId"></client-booking-tab>
                        </div>
                    </ng-container>
                </p-tabpanel>
                
                <!-- Subscriptions Panel -->
                <p-tabpanel [value]="'4'" [attr.aria-label]="'subscriptions-panel'" [attr.id]="'tab-content-4'" [attr.aria-labelledby]="'tab-label-4'">
                    <ng-container *ngIf="activeIndex === 4 && clientId">
                        <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'subscriptions-tab-content'">
                            <subscription-list [clientId]="clientId" [client]="client!"></subscription-list>
                        </div>
                    </ng-container>
                </p-tabpanel>
                
                <!-- Transactions Panel -->
                <p-tabpanel [value]="'5'" [attr.aria-label]="'transactions-panel'" [attr.id]="'tab-content-5'" [attr.aria-labelledby]="'tab-label-5'">
                    <ng-container *ngIf="activeIndex === 5 && clientId">
                        <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'transactions-tab-content'">
                            <transaction-tab [clientId]="clientId" (updateData)="updateData($event)"></transaction-tab>
                        </div>
                    </ng-container>
                </p-tabpanel>
                
                <!-- Trial Panel -->
                <p-tabpanel [value]="'6'" [attr.aria-label]="'trial-panel'" [attr.id]="'tab-content-6'" [attr.aria-labelledby]="'tab-label-6'">
                    <ng-container *ngIf="activeIndex === 6 && clientId">
                        <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'trial-tab-content'">
                            <client-trial-tab [clientId]="clientId"></client-trial-tab>
                        </div>
                    </ng-container>
                </p-tabpanel>
                
                <!-- Task Panel -->
                <p-tabpanel [value]="'7'" [attr.aria-label]="'task-panel'" [attr.id]="'tab-content-7'" [attr.aria-labelledby]="'tab-label-7'">
                    <ng-container *ngIf="activeIndex === 7 && clientId">
                        <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'task-tab-content'">
                            <client-task-tab [clientId]="clientId"></client-task-tab>
                        </div>
                    </ng-container>
                </p-tabpanel>
                
                <!-- Check In Panel -->
                <p-tabpanel [value]="'8'" [attr.aria-label]="'check-in-panel'" [attr.id]="'tab-content-8'" [attr.aria-labelledby]="'tab-label-8'">
                    <ng-container *ngIf="activeIndex === 8 && clientId">
                        <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'check-in-tab-content'">
                            <fitness-force-client-checkin-tab [clientId]="clientId" [client]="client!"></fitness-force-client-checkin-tab>
                        </div>
                    </ng-container>
                </p-tabpanel>
                
                <!-- Migration Panel -->
                <p-tabpanel [value]="'9'" [attr.aria-label]="'migration-panel'" [attr.id]="'tab-content-9'" [attr.aria-labelledby]="'tab-label-9'">
                    <ng-container *ngIf="activeIndex === 9 && clientId && client?.migration_id">
                        <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'migration-tab-content'">
                            <client-migration-tab [clientId]="clientId"></client-migration-tab>
                        </div>
                    </ng-container>
                </p-tabpanel>
                
                <!-- Fitness Panel -->
                <p-tabpanel [value]="'10'" [attr.aria-label]="'fitness-panel'" [attr.id]="'tab-content-10'" [attr.aria-labelledby]="'tab-label-10'">
                    <ng-container *ngIf="selectedMenu?.key === 'fitness' && clientId && clientUuid">
                        <div class="lg:h-screen overflow-y-auto surface-100 lg:pb-8" [attr.data-testid]="'fitness-tab-content'">
                            <client-fitness-tab [client_uuid]="clientUuid"></client-fitness-tab>
                        </div>
                    </ng-container>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </div>
    <!-- Right Side -->
</div>
